/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2025, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 *
 */

export const MEDIA_CONFIG = {
  options: [
    'bulbInsertImage',
    'bulbInsertImageCarousel',
    'bulbInsertVideo',
    'bulbInsertAttachedFile',
    'bulbInsertAudio',
    'bulbInsertMediaEmbed',
    'insertTable',
    'horizontalLine',
  ],
};

export const BULB_HEADING = {
  options: [
    { model: 'paragraph', class: 'ck-heading_paragraph' },
    { model: 'heading2', class: 'ck-heading_heading2' },
    { model: 'heading3', class: 'ck-heading_heading3' },
  ],
};

export const EMBED = {
  toolbar: [
    'blockAlignment:alignLeft',
    'blockAlignment:alignCenter',
    'blockAlignment:alignRight',
    'bulbDeleteBlock',
  ],
};

export const BULB_IMAGE = {
  toolbar: [
    'blockAlignment:imageAlignLeft',
    'blockAlignment:alignCenter',
    'blockAlignment:imageAlignRight',
    '|',
    'bulbRotateImage',
    'bulbCropImage',
    'linkImage',
    'bulbDeleteBlock',
  ],
};

export const BULB_IMAGE_CROP = {
  toolbar: [
    'bulbImageCropCancel',
    'bulbImageCropConfirm',
  ],
};

export const BULB_CAROUSEL_TRANSITION = {
  options: [
    'SLIDE',
    'FADE',
    'FLIP',
    'CUBE',
  ],
};

export const IMAGE_CAROUSEL = {
  toolbar: [
    'bulbCarouselTransition',
    'bulbAddSlide',
    'bulbRemoveSlide',
    'bulbDeleteBlock',
  ],
};

export const AUDIO = {
  toolbar: [
    'blockAlignment:alignLeft',
    'blockAlignment:alignCenter',
    'blockAlignment:alignRight',
    'bulbDeleteBlock',
  ],
};

export const VIDEO = {
  toolbar: [
    'blockAlignment:alignLeft',
    'blockAlignment:alignCenter',
    'blockAlignment:alignRight',
    'bulbDeleteBlock',
  ],
};

export const ATTACHED_FILE = {
  toolbar: [
    'blockAlignment:alignLeft',
    'blockAlignment:alignCenter',
    'blockAlignment:alignRight',
    'bulbDeleteBlock',
  ],
};

export const blockAlignment = {
  options: [
    'alignLeft',
    'alignCenter',
    'alignRight',
    'imageAlignLeft',
    'imageAlignRight',
  ],
};

export const BULB_CKE_LIST = {
  options: [
    'bulletedList',
    'numberedList',
    'todoList',
  ],
};

/**
 * Configuration of balloon toolbar.
 */
export const COMMENTS_CONFIGURE = {
  toolbar: {
    items: [
      'bulbComment',
    ],
  },
  audio: {
    toolbar: ['bulbComment'],
  },
  video: {
    toolbar: ['bulbComment'],
  },
  bulbImage: {
    toolbar: ['bulbComment'],
  },
  imageCarousel: {
    toolbar: ['bulbComment'],
  },
  attachedFile: {
    toolbar: ['bulbComment'],
  },
  embed: {
    toolbar: ['bulbComment'],
  },
};

export function getToolBarConfig(type: string, isReadOnly: boolean): string[] {
  const config = {
    bulbImage: isReadOnly ? COMMENTS_CONFIGURE.bulbImage.toolbar : BULB_IMAGE.toolbar,
    audio: isReadOnly ? COMMENTS_CONFIGURE.audio.toolbar : AUDIO.toolbar,
    video: isReadOnly ? COMMENTS_CONFIGURE.video.toolbar : VIDEO.toolbar,
    attachedFile: isReadOnly ? COMMENTS_CONFIGURE.attachedFile.toolbar : ATTACHED_FILE.toolbar,
    embed: isReadOnly ? COMMENTS_CONFIGURE.embed.toolbar : EMBED.toolbar,
    imageCarousel: isReadOnly ? COMMENTS_CONFIGURE.imageCarousel.toolbar : IMAGE_CAROUSEL.toolbar,
  };

  return config[type] || [];
}
